import React, { useEffect, useState } from "react";
import {
  BankOutlined,
  TeamOutlined,
  EnvironmentOutlined,
  ArrowRightOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import "./jobListingWhoIsHiringNowPage.scss";
import JobListingsPageHeader from "../jobListingPageHeader";
import useNuJobsStore from "../../../store/nujobs.store";

const JobListingWhoIsHiringNowPage = () => {
  const [activeType, setActiveType] = useState("all");
  const navigate = useNavigate();
  const { hiringCompanies, nuJobsEmployerWhoisHiring } = useNuJobsStore();

  useEffect(() => {
    nuJobsEmployerWhoisHiring(0);
  }, [nuJobsEmployerWhoisHiring]);

  const companies = Array.isArray(hiringCompanies) ? hiringCompanies : [];

  const totalCompanies = companies.length;
  const totalActiveJobs = companies.reduce(
    (total, company) => total + (Number(company.openJobs) || 0),
    0
  );

  const filteredCompanies =
    activeType === "all"
      ? companies
      : companies.filter((company) => company.type === activeType);

  const handleViewJobs = (company) => {
    navigate(`/nujobswhoishiringnowcompany/company/${company.id}`);
  };

  return (
    <div className="whos-hiring-page">
      <JobListingsPageHeader />

      <section className="whos-hiring-section">
        <div className="whos-hiring-intro">
          <div className="whos-hiring-intro-heading">
            <div className="intro-icon">
              <BankOutlined />
            </div>

            <div>
              <h1>Who's Hiring Now</h1>
              <p>
                Discover companies actively hiring. Explore direct employers
                and recruitment partners with open opportunities on NuJobs.
              </p>
            </div>
          </div>

          <div className="whos-hiring-intro-stats">
            <div className="intro-stat">
              <BankOutlined />
              <div>
                <strong>{totalCompanies}</strong>
                <span>Companies Hiring</span>
              </div>
            </div>

            <div className="intro-stat">
              <TeamOutlined />
              <div>
                <strong>{totalActiveJobs}</strong>
                <span>Active Jobs</span>
              </div>
            </div>
          </div>
        </div>

        <div className="whos-hiring-filters">
          <button
            type="button"
            className={activeType === "all" ? "active" : ""}
            onClick={() => setActiveType("all")}
          >
            All
          </button>

          <button
            type="button"
            className={activeType === "direct" ? "active" : ""}
            onClick={() => setActiveType("direct")}
          >
            <BankOutlined />
            Direct Employers
          </button>

          <button
            type="button"
            className={activeType === "partner" ? "active" : ""}
            onClick={() => setActiveType("partner")}
          >
            <TeamOutlined />
            Recruitment Partners
          </button>
        </div>

        <div className="whos-hiring-grid">
          {filteredCompanies?.map((company) => (
            <div className="hiring-company-card" key={company.id}>
              <div className="company-card-top">
                <div className="company-logo">
                  {company.logo ? (
                    <img src={company.logo} alt={company.name} />
                  ) : company.type === "direct" ? (
                    <BankOutlined />
                  ) : (
                    <TeamOutlined />
                  )}
                </div>

                <div className="hiring-status">
                  <span className="hiring-dot" />
                  Hiring Now
                </div>
              </div>

              <div className="company-name" title={company.name}>
                {company.name}
              </div>

              <div className="company-type">
                <CheckCircleFilled />
                {company.type === "direct"
                  ? "Direct Employer"
                  : "Recruitment Partner"}
              </div>

              <div className="company-job-count">
                <strong>{company.openJobs}</strong>
                <span> Active Jobs</span>
              </div>

              <div className="company-location">
                <EnvironmentOutlined />
                <span>{company.location}</span>
              </div>

              <button
                type="button"
                className="company-view-jobs"
                onClick={() => handleViewJobs(company)}
              >
                View Open Jobs
                <ArrowRightOutlined />
              </button>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default JobListingWhoIsHiringNowPage;
